const DISPLAY_MODES = {
  FAQ: 'faq',
  GRID_WITH_BACKGROUND: 'grid-with-background',
  TILE_LIST_5X7: 'tile-list-5x7',
}

export default DISPLAY_MODES
